import React from "react";
import "animate.css";
import warehouseImg from "../../../assets/warehouse.png"


function WorkspaceInst() {
  const Instructions= [
    {
      title:"Provide workspace instructions for every possible area",
    },
    {
      title:"Production",
    },
    {
      title:"Quality control",
    },
    {
      title:"Repairs",
    },
    {
      title:"Set up",
    },
    {
      title:"Design any guide for any item, whether assembly or part on its own",
    },
  ]
  return (
    <div className="animate__animated animate__zoomIn">
      <div className="container  w-11/12  shadow-5xl  mx-auto  px-8 py-8 my-28">
        <div className="grid grid-cols-2 gap-20 font-Montserrat">
          <div className="md:flex md:flex-col content-start  justify-items-start">
            <h2 className="text-blue-200 text-2xl font-bold">
              Workspace Instruction
            </h2>
            {Instructions.map((item, i) => (
             <div key={i} className="list-item pt-2 ml-8">
             
             <div>{item.title}</div>
           </div>
            ))}
           
          </div>
          <div className="md:flex md:flex-col content-start  justify-items-start">
            <div>
              <img
                src={warehouseImg}
                alt="Logo"
                className="h-80 rounded-sm  "
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WorkspaceInst;
